import type { SxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';

interface ContainerProps {
  isWhite?: boolean;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const Container: React.FC<ContainerProps> = ({ isWhite, children, sx }) => {
  return (
    <Box
      sx={{
        p: 'var(--spacing-md)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...(isWhite && {
          backgroundColor: 'var(--color-white)',
        }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
